import { Filter } from './enums';

export const FEET_PER_METERS = 3.28084;
export const LANIGAN_SITE_ID = '9d900b61-195c-433c-94ee-155a2570d653';
export const DEFAULT_SHIFT_ID = '7719b5fa-8139-4c90-95e4-584f69fbade4';
export const AREA_CHECK_STORAGE_KEY = 'AreaCheck';
export const AREA_CHECK_TAB_INDEX = 'AreaCheckTabIndex';
export const USER_NOT_FOUND_CODE = 'UserNotFoundException';
export const NOT_AUTHORIZED_CODE = 'NotAuthorizedException';
export const USER_WITHOUT_WORKPACKAGES = `You don't have any assigned workpackages to perform
                                          inspection, please contact admin for further details.`;
export const DELETE_BUTTON = 'Yes, Delete';
export const DELETE_CONFIRM = 'Are you sure?';
export const DELETE_CONFIRM_NAME = 'Do you want to Delete ';
export const SAP_ID = 'SAP ID';
export const EAM_ID = 'EAM ID';
export const DEFICIENCY_CATEGORY = 9;
export const EDIT_DETAILS = 'Edit Details';
export const DELETE = 'Delete';
export const COPY = 'Copy';
export const PDF = 'application/pdf';
export const DOC = 'application/msword';
export const DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const MP4 = 'video/mp4';
export const MP3 = 'audio/mpeg';
export const MOV = 'video/mov';
export const TEXT = 'text/plain';
export const XLS = 'application/vnd.ms-excel';
export const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PNG = 'image/png';
export const JPEG = 'image/jpeg';
export const XML_HEADER = 'application/xml';
export const BATCH_SIZE = 250;
export const BATCH_SIZE_REASSIGN = 5;
export const DEFAULT_DATE = '1900-01-01T01:01:01.1234567-06:00';

export const DATE_OBSERVED = 'YYYY-MM-DDTHH:MM:SS.SSSZ';
export const DEFER_UPDATE_DURATION = 'deferUpdateDuration';
export const YYYYMMDD_DATE_FORMAT = 'YYYY-MM-DD';
export const CONFIGCAT_DEFAULT_POLLING_INTERVAL_SECONDS = 60;

export const ST = { rating: [1, 2, 3, 4, 5], urgency: [1, 3, 5] };
export const SH = { rating: [3, 4, 5], urgency: [1, 3, 5] };
export const MI = { rating: [1, 2, 3, 4, 5], urgency: [1, 3, 5] };
export const EL = { rating: [1, 2, 3, 4, 5], urgency: [1, 2, 3, 4, 5] };

export const offlineTextMsg = 'User Need To Connected With Internet To See This Data.';
export const FILES_TO_OPEN = ['pdf', 'mp4', 'mp3', 'txt'];
export const FILES_TO_DOWNLOAD = ['csv', 'xlsx', 'xls', 'ppt', 'pptx', 'docx', 'doc', 'mov'];
export const FILES_IMAGE_TYPE = ['jpeg', 'jpg', 'png'];

export const RISK_ASSESSMENT_PAYLOAD = ['operationalDowntime', 'rating', 'trafficScore', 'urgency'];

export const PMheader = 'Preventative Maintenance Checklist';
export const PMsubtitle =
  '* Mandatory to check all the below steps to submit Preventative Maintenance';
export const UPLOAD_RETRY = 15000;

/*InspectionList Start */
export const FALSE = 'False';
export const TRUE = 'True';
export const SORT_BY_DESC = 'desc';
export const SORT_BY_ASC = 'asc';

export const IMAGE_PATH = '../../assets/images';

export const KEEP_LOGGED_IN_KEY = 'aws-amplify-remember-me';
export const KEEP_LOGGED_IN_EXPIRY_TIME_KEY = 'aws-amplify-remember-me-expiry';
export const REMEMBER_ME_EMAIL = 'remember-me-email';

export const APP_BAR_BLACK_LISTED_PATH = [
  '/login',
  '/logout',
  '/initializing',
  '/home',
  '/signup',
  '/forgot-password',
  '/initialize',
];

// Confirmation messages
export const SUBMIT_FOR_LI_REVIEW = `Once you submit the inspection you can't make further changes. Are you sure to submit the inspection to Lead Inspector for review?`;
export const SUBMIT_FOR_FI_SIGN_STAMP = `Once you submit the Inspection, it cant be Assigned back. Are you sure to submit the Inspection for FI Sign and Stamp?`;
export const SUBMIT_FOR_SC_REVIEW = `Are you sure want to submit the Inspection to Site Coordinator Review?`;
export const UPDATING_SIGN_AND_STAMP = `Once you upload and send the Signature and Stamping you can't make any further changes. Are you sure to send the Signature & Stamping?`;
export const UPDATING_LI_SIGN_STAMP_ADHOC = `Once you upload & send the Signature and Stamp, Inspection would be sent for SC Review. Are you sure to upload Signature & Stamping?`;
export const COMPLETING_INSPECTION = `Once you upload & send the Signature and Stamp, Inspection would be completed. Are you sure to upload Signature & Stamping?`;
export const INSPECTION_ASSIGN_BACK_TO_FI = `Are you sure you want to assign the Inspection back to Field Inspector?`;
export const INSPECTION_ASSIGN_BACK_TO_DEC = `Are you sure you want to assign the Inspection back to Data Entry Clerk?`;
export const INSPECTION_SUBMIT_TO_SC = `Are you sure you want to submit the Inspection for Site Coordinator Review?`;
export const INSP_BY_DEC_SUBMIT_FOR_LI_SIGN_OFF = `Are you sure you want to submit the Inspection for Site Coordinator Review? You will be directed to signature/stamping page on Submitting`;
export const ADHOC_FI_SIGN_DONE_SUBMIT_FOR_LI_SIGN_OFF = `Field Inspector already signed off for the Inspection. Are you sure you want to submit the Inspection for Lead Inspector Sign off?`;
export const FI_SIGN_DONE_SUBMIT_FOR_LI_REVIEW = `FI sign already exists on task, submitting it would move task status to LI Review Pending. Do you want to continue?`;
export const LI_SIGN_DONE_SUBMIT_TO_SC = `Lead Inspector sign is already done. Are you sure you want to submit the Inspection for Site Coordinator Review?`;
export const ADHOC_LI_SIGN_OFF_DONE_SUBMIT_TO_SC = `Lead Inspector already signed off for the Inspection. Are you sure you want to submit the Inspection for Site Coordinator Review?`;
export const ADHOC_LI_FI_SIGN_DONE_SUBMIT_TO_SC = `Lead and Field Inspectors already signed off for the Inspection. Are you sure you want to submit the Inspection for Site Coordinator Review?`;
export const ADHOC_SUBMIT_FOR_LI_SIGN_OFF = `Are you sure you want to submit the Inspection for Lead Inspector Sign Off?`;
export const ADHOC_SUBMIT_FOR_FI_SIGN_OFF = `Are you sure you want to submit the Inspection for Field Inspector Sign Off?`;
export const ADHOC_SUBMIT_TO_SC = `Are you sure you want to submit the Inspection for Site Coordinator Review?`;
export const DEC_SUBMIT_TO_LI = `Are you sure you want to submit the Inspection for Lead Inspector Review?`;
export const TITLE_SIGN_OFF = `Submit Inspection for Sign off`;
export const TITLE_REVIEW = `Submit Inspection for Review`;
export const TITLE_COMPLETED = `Confirmation`;
export const NOTIFICATION_ASSIGN_BACK = `Assigned back to Field Inspector Successfully!`;
export const NOTIFICATION_ASSIGN_BACK_DEC = `Assigned back to Data Entry Clerk Successfully!`;
export const NOTIFICATION_SC_REVIEW = `Inspection submitted to Site Coordinator Successfully!`;
export const NOTIFICATION_LI_SIGN_OFF = `Inspection submitted successfully for Lead Inspector Sign off!`;
export const NOTIFICATION_FI_SIGN_OFF = `Inspection submitted successfully for Field Inspector Sign off!`;
export const COMPLETING_INSPECTION_FROM_INPROGRESS = `Once you submit the inspection you can't make further changes, Inspection would be completed. Are you sure to submit the Inspection?`;

export const WORK_PACKAGE_NAV_TAB = {
  WORKPACKAGE: {
    LABEL: 'Work Packages',
    VALUE: 0,
  },
  ADHOC: {
    LABEL: 'Adhoc Inspections',
    VALUE: 1,
  },
};

export const WORK_PACKAGE_NAV_TAB_OPTIONS = [
  { label: WORK_PACKAGE_NAV_TAB.ADHOC.LABEL, value: WORK_PACKAGE_NAV_TAB.ADHOC.VALUE },
  { label: WORK_PACKAGE_NAV_TAB.WORKPACKAGE.LABEL, value: WORK_PACKAGE_NAV_TAB.WORKPACKAGE.VALUE },
];

export const ALLOW_EXTENSIONS = /(\.jpg|\.jpeg|\.png|\.gif|\.svg )$/i;

export const INVALID_FILE_TYPE = 'Invalid file type';

// eslint-disable-next-line
export const SPECIAL_CHARACTER_ERROR =
  'Please rename your file as file names with these [`,~,*,@,#,$,%,^,&,,+,=,{,},[,,],:,;,<>,?,/,,], special characters cannot be uploaded';

export const INVALID_FILE = 'Few files might not be uploaded due to unsupported file format';

export const INVALID_DATE = 'Invalid Date';

export const MAX_DATE = 'Date should not be after maximal date';

export const REGEX_EMAIL = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;

export const DEFICIENCY_SORTBY_DEFAULT_VALUE = {
  name: Filter.NONE,
  componentType: Filter.NONE,
  conditionRating: Filter.NONE,
  remedialAction: Filter.NONE,
  urgency: Filter.NONE,
  areaId: Filter.NONE,
  dateObserved: Filter.NONE,
  repairFactor: Filter.NONE,
  actionType: Filter.NONE,
  status: Filter.NONE,
  removedFromPlanning: Filter.NONE,
};

export const INSPECTION_LENGTH_WHILE_BULK = 50;
export const LAST_SYNC = 'lastSync';
